/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manage_RosterInputs */

const th_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดการผู้เล่น`)
};

const en_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage squad`)
};

const ja_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンバーを管理`)
};

const zh_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理阵容`)
};

const es_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar plantilla`)
};

const pt_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar elenco`)
};

const id_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelola skuad`)
};

const fr_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer l’effectif`)
};

const tl_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pamahalaan ang squad`)
};

const vi_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản lý đội hình`)
};

const ko_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수단 관리`)
};

const de_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kader verwalten`)
};

const ru_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управлять составом`)
};

const tr_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kadroyu yönet`)
};

const it_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci la rosa`)
};

const pl_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj składem`)
};

const uk_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Керувати складом`)
};

const hi_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम प्रबंधित करें`)
};

const ar_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدارة التشكيلة`)
};

const ms_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urus skuad`)
};

const bn_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল পরিচালনা করুন`)
};

const zh_tw2_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理名單`)
};

const zh_hk2_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理名單`)
};

const ur_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسکواڈ کا انتظام`)
};

const fa_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدیریت فهرست تیم`)
};

const sw_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simamia kikosi`)
};

const nl_manage_roster = /** @type {(inputs: Manage_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectie beheren`)
};

/**
* | output |
* | --- |
* | "Manage squad" |
*
* @param {Manage_RosterInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const manage_roster = /** @type {((inputs?: Manage_RosterInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manage_RosterInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_manage_roster(inputs)
	if (locale === "ja") return ja_manage_roster(inputs)
	if (locale === "zh") return zh_manage_roster(inputs)
	if (locale === "es") return es_manage_roster(inputs)
	if (locale === "pt") return pt_manage_roster(inputs)
	if (locale === "id") return id_manage_roster(inputs)
	if (locale === "fr") return fr_manage_roster(inputs)
	if (locale === "tl") return tl_manage_roster(inputs)
	if (locale === "vi") return vi_manage_roster(inputs)
	if (locale === "ko") return ko_manage_roster(inputs)
	if (locale === "de") return de_manage_roster(inputs)
	if (locale === "ru") return ru_manage_roster(inputs)
	if (locale === "tr") return tr_manage_roster(inputs)
	if (locale === "it") return it_manage_roster(inputs)
	if (locale === "pl") return pl_manage_roster(inputs)
	if (locale === "uk") return uk_manage_roster(inputs)
	if (locale === "hi") return hi_manage_roster(inputs)
	if (locale === "ar") return ar_manage_roster(inputs)
	if (locale === "ms") return ms_manage_roster(inputs)
	if (locale === "bn") return bn_manage_roster(inputs)
	if (locale === "zh-TW") return zh_tw2_manage_roster(inputs)
	if (locale === "zh-HK") return zh_hk2_manage_roster(inputs)
	if (locale === "ur") return ur_manage_roster(inputs)
	if (locale === "fa") return fa_manage_roster(inputs)
	if (locale === "sw") return sw_manage_roster(inputs)
	if (locale === "nl") return nl_manage_roster(inputs)
	return en_manage_roster(inputs)
});